/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The WalletControllerDtoDashboardAvailableBalanceRequest model module.
 * @module model/WalletControllerDtoDashboardAvailableBalanceRequest
 * @version 1.0
 */
class WalletControllerDtoDashboardAvailableBalanceRequest {
    /**
     * Constructs a new <code>WalletControllerDtoDashboardAvailableBalanceRequest</code>.
     * @alias module:model/WalletControllerDtoDashboardAvailableBalanceRequest
     */
    constructor() { 
        
        WalletControllerDtoDashboardAvailableBalanceRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>WalletControllerDtoDashboardAvailableBalanceRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/WalletControllerDtoDashboardAvailableBalanceRequest} obj Optional instance to populate.
     * @return {module:model/WalletControllerDtoDashboardAvailableBalanceRequest} The populated <code>WalletControllerDtoDashboardAvailableBalanceRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new WalletControllerDtoDashboardAvailableBalanceRequest();

            if (data.hasOwnProperty('beginDate')) {
                obj['beginDate'] = ApiClient.convertToType(data['beginDate'], 'Date');
            }
            if (data.hasOwnProperty('endDate')) {
                obj['endDate'] = ApiClient.convertToType(data['endDate'], 'Date');
            }
            if (data.hasOwnProperty('hourly')) {
                obj['hourly'] = ApiClient.convertToType(data['hourly'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>WalletControllerDtoDashboardAvailableBalanceRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>WalletControllerDtoDashboardAvailableBalanceRequest</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Date} beginDate
 */
WalletControllerDtoDashboardAvailableBalanceRequest.prototype['beginDate'] = undefined;

/**
 * @member {Date} endDate
 */
WalletControllerDtoDashboardAvailableBalanceRequest.prototype['endDate'] = undefined;

/**
 * @member {Boolean} hourly
 */
WalletControllerDtoDashboardAvailableBalanceRequest.prototype['hourly'] = undefined;






export default WalletControllerDtoDashboardAvailableBalanceRequest;

